import { createComponent } from "react-fela";

import SummaryGrid from "~/components/resource/summary/grid";

export default ({ resources, hasSidebar, type }) => {
    return (
        <ResourceListing hasSidebar={hasSidebar}>
            {resources &&
                resources.length &&
                resources.map(resource => {
                    return (
                        <SummaryGrid
                            resource={resource}
                            key={resource.slug}
                            type={type}
                            collectionLength={resources.length}
                        />
                    );
                })}
        </ResourceListing>
    );
};

const ResourceListing = createComponent(({ hasSidebar }) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    extend: [
        {
            condition: hasSidebar,
            style: {
                flexBasis: "75%"
            }
        }
    ]
}));
